import React, { useState } from "react";
import ReactDOM from "react-dom/client";
import { QrReader } from 'react-qr-reader';

export const renderScanner = (onScanSuccess, onScanFailure) => {
  const root = ReactDOM.createRoot(document.getElementById('react-qr-scanner'));
  //const scannerPromise = new Promise((resolve, reject) => {
    root.render(
      <ScannerWidget
        isFacingUser={false}
        onScanFailure={onScanFailure}
        onScanSuccess={onScanSuccess}
        root={root}
      />,
    )
  //});
  //return photoPromise;
};


const ScannerWidget = ({isFacingUser, root, onScanFailure, onScanSuccess}) => {

  const [facingUser, setFacingUser] = useState(isFacingUser)

  const facingUserConstraints = { facingMode: "environment" };
  const facingEnvironmentConstraints = { facingMode: "user" };

  const onResult = (result, error, root) => {
    if (!!result) {
      onScanSuccess(result.text);
      closeCamera(root);
    }

    if (!!error) {
      if (error.toString() != "e2") {
        closeCamera(root);
        onScanFailure(error)
      }
    }
  }

  const closeCamera = () => {
    root.unmount()
  }

  return (
    <div className="ScannerWidget">
      <div className="camera-container">
        <div className="row end">
          <button onClick={closeCamera}>
            <img className="close" src="/art/workshop/close_btn__active.png" />
          </button>
        </div>
        { facingUser ?
          <QrReader
            key='user'
            onResult={(result, error) => onResult(result, error, root)}
            constraints={facingUserConstraints}
            className="scanner-container"
            style={{ width: "100%" }}
          />
          :
          <QrReader
            key='environment'
            onResult={(result, error) => onResult(result, error, root)}
            constraints={facingEnvironmentConstraints}
            className="scanner-container"
            style={{ width: "100%" }}
          />
        }
        <div className="row">
          <button className="direction" onClick={() => setFacingUser(!facingUser)}>
            <img src="/art/workshop/arrow-circle-3.svg" />
          </button>
        </div>
      </div>
    </div>
  );
};
